import { TYPE_PRODUCT } from '@/constants';
import { getRandomInt, uncapitalizeFirstLetter } from '@/utilities';
import Story from '@/models/Task/Story';

import DeliveryQueue from '@/mixins/DeliveryQueue';

let productCount = 0;

export default class Product {
  constructor() {
    productCount += 1;

    this.type = TYPE_PRODUCT;
    this.name = `Product #${productCount}`;
    this.subTasks = [];
    this.taskDeliverCoord = [0, 0];
    this.skills = {};

    this.addSkill(new DeliveryQueue());
    this.createStories();
  }

  addSkill(skillInstance) {
    this.skills[uncapitalizeFirstLetter(skillInstance.constructor.name)] = skillInstance;
  }

  createStories() {
    const random = getRandomInt(1, 5);
    for (let i = 0; i < random; i += 1) {
      const story = new Story({
        product: this,
      });
      this.subTasks.push(story);
      this.skills.deliveryQueue.addItems(story);
    }
  }

  get progress() {
    if (this.subTasks.length === 0) {
      return 0;
    }
    return this.subTasks.reduce((acc, task) => acc + task.progress, 0) / this.subTasks.length;
  }

  get bugRatio() {
    if (this.subTasks.length === 0) {
      return 0;
    }
    return this.subTasks.reduce((acc, task) => acc + task.subtaskHasBug, 0) / this.subTasks.length;
  }

  // Product 管 Task 的人，每次 Product 下面有任何 Task 產生或是進度被更新，它應該要知道
  // 要用什麼方式知道？ 跟哪個 Team 的哪個人做完沒有關係，是 Task 狀態改變了，Product 要知道
  // Product 會根據 Task 狀態來決定它下面的某些 property 要變成什麼，而不是別人來去跟 Product 說你要幹嘛
  // Product 只會關心 Task 的狀態改變

  addStory() {
    const story = new Story({ product: this });
    this.subTasks.push(story);
    this.skills.deliveryQueue.addItems(story);
  }
}
